module.exports = __webpack_public_path__ + "static/media/supportG4F.3c204272.jpg";